module.exports = __webpack_public_path__ + "static/img/boss.55d5f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/company/boss.jpg
// module id = 6Wrt
// module chunks = 1